module.exports = __webpack_public_path__ + "static/media/IMG_5701.dc5ab723.jpg";